// Global Instructions Rule Applied!
import React from 'react'
import { useDispatch } from 'react-redux'
import { FormSection } from '../../../../../core/components/FormSection.tsx'
import { InputManager } from '../../../../../core/components/InputManager/index.ts'
import { useCurrencies } from '../../../../currencies/useCurrencies.ts'
import { useLookups } from '../../../../global_configs/hooks/useLookups.ts'
import { updateDealRecord } from '../../../../../state_manager/state_update_actions/deals/index.ts'
import { DealFields } from '../../../../../state_manager/data_models/deal_record.ts'
import { getCompanyFields } from '../../../utils/fieldConfigs.ts'

interface CompanySectionProps {
  formData?: any
  handleFieldChange?: (key: string, value: any) => void
  onPatchSuccess?: (patchRecordId: string, updates: Record<string, any>) => void
  isReadOnly?: boolean
  recordId?: string | number | null
  cardProps?: any
  getCompanyDetailsById?: (id: string) => Promise<any> | any
}

export function CompanySection({
  formData,
  handleFieldChange,
  onPatchSuccess,
  isReadOnly = false,
  recordId = null,
  cardProps = {},
  getCompanyDetailsById
}: CompanySectionProps) {
  const { getCurrencyById, getCurrencyOptions } = useCurrencies()
  const { getLookupOptions } = useLookups()
  const dispatch = useDispatch()

  const data = formData || {}

  const dealId = recordId || data[DealFields.deals__id] || data.id

  const accountId = data[DealFields.accounts__id] || data[DealFields.deals__account] || data.account_id

  const fieldOptions = {
    getCompanyDetailsById,
    getLookupOptions,
    getCurrencyById,
    getCurrencyOptions: getCurrencyOptions()
  }

  const handlePatchSuccessLocal = (patchRecordId: string, updates: Record<string, any>) => {
    if (onPatchSuccess) {
      onPatchSuccess(patchRecordId, updates)
    } else {
      dispatch(updateDealRecord({ dealId: dealId, updates }))
    }
  }

  return (
    <FormSection
      data-debug='company-section'
      data-component='CompanySection'
      title='Company'
      titleColor='blue'
      {...cardProps}
    >
      <div data-debug='company-section-content'>
        <InputManager
          inputMode='read'
          labelPosition='inline'
          fields={getCompanyFields(data, fieldOptions, isReadOnly)}
          onChange={(key: string, value: any) => handleFieldChange?.(key, value)}
          enableAutoPatch={!isReadOnly && !!accountId}
          patchId={accountId}
          recordId={dealId}
          onPatchSuccess={handlePatchSuccessLocal}
          className='company-section-fields'
        />
      </div>
    </FormSection>
  )
}
